import { TreeView } from "./tree-view";
import { TreeNode } from "./tree-node";
export * from "./tree-view";
export * from "./tree-node";
export var TREE_VIEW_DIRECTIVES = [
    TreeNode,
    TreeView
];
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/clarity-angular/data/tree-view/index.js
// module id = 176
// module chunks = 4